import React from 'react';
import { Header, SubFooter } from 'Atoms/';
import { Change } from 'Molecules/';

export default function change() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="ʻĪao Valley"
        title2="State Monument"
        url="iao-valley"
      />
      <Change url="iao-valley" parkid="63edc307c8f7df7ca39389d0" />
      <SubFooter name="ʻĪao Valley State Monument" url="iao-valley" />
    </div>
  );
}
